"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as MantineMenu, MenuDivider, MenuDropdown, MenuItem, MenuLabel, MenuTarget, useProps, } from "@mantine/core";
import "@mantine/core/styles/Popover.layer.css";
import "@mantine/core/styles/Menu.layer.css";
import * as styles from "./Menu.module.css";
const Menu = (props) => {
    const modifiedProps = useProps("Menu", {
        classNames: styles,
        shadow: "var(--mantine-shadow-lg)",
    }, props);
    return _jsx(MantineMenu, { ...modifiedProps });
};
Menu.displayName = "Menu";
MenuDivider.displayName = "MenuDivider";
MenuDropdown.displayName = "MenuDropdown";
MenuItem.displayName = "MenuItem";
MenuLabel.displayName = "MenuLabel";
MenuTarget.displayName = "MenuTarget";
Menu.Divider = MenuDivider;
Menu.Dropdown = MenuDropdown;
Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Target = MenuTarget;
export { Menu, };
//# sourceMappingURL=Menu.js.map